import { useEffect } from "react";

const EVENT = "Cpenz:portal-panel";

/** Only one floating panel (menu stacks, tasks, notifications) may be open at a time. */
export const announcePanel = (id) => window.dispatchEvent(new CustomEvent(EVENT, { detail: id }));

export function useSinglePanel(id, isOpen, close) {
  useEffect(() => {
    if (!isOpen) return;
    announcePanel(id);
    const onOther = (e) => { if (e.detail !== id) close(); };
    window.addEventListener(EVENT, onOther);
    return () => window.removeEventListener(EVENT, onOther);
  }, [id, isOpen, close]);
}
